module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full flex flex-col h-full space-y-4 px-6 py-4 overflow-y-auto"
  }, [(_vm.isLoading) ? _c('div', [_vm._v("\n    Loading....\n  ")]) : _c('div', {
    staticClass: "h-full w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-x-12 h-full"
  }, [_c('div', {
    staticClass: "w-full h-full overflow-y-auto flex flex-col col-span-12"
  }, [(_vm.transcription.length > 0) ? _c('div', {
    staticClass: "w-full flex flex-col items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "relative w-full flex flex-col items-center"
  }, [_c('div', {
    staticClass: "absolute top-0 left-1/2 transform -translate-x-1/2 h-full border-r-2 border-gray-200"
  }), _vm._v(" "), _vm._l((_vm.transcription), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "my-8 flex w-full",
      class: {
        'flex-row-reverse': index % 2 !== 0
      }
    }, [(index % 2 === 0) ? _c('div', {
      staticClass: "w-1/2 flex items-center space-x-3 justify-end pr-8"
    }, [(user.turns === null) ? _c('div', [_c('i', {
      staticClass: "fa-solid fa-crown text-yellow-500 text-base"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "w-10 h-10 rounded-full flex items-center justify-center overflow-hidden"
    }, [_c('img', {
      staticClass: "w-full h-full object-cover",
      attrs: {
        "src": user.users.avatar_url,
        "alt": "Avatar"
      }
    })])]) : _c('div', {
      staticClass: "relative w-1/2 pl-8 flex space-x-3 items-center"
    }, [_c('div', {
      staticClass: "w-10 h-10 rounded-full flex items-center justify-center overflow-hidden"
    }, [_c('img', {
      staticClass: "w-full h-full object-cover",
      attrs: {
        "src": user.users.avatar_url,
        "alt": "Avatar"
      }
    })]), _vm._v(" "), (user.turns === null) ? _c('div', [_c('i', {
      staticClass: "fa-solid fa-crown text-yellow-500"
    })]) : _vm._e()]), _vm._v(" "), (index % 2 === 0) ? _c('div', {
      staticClass: "relative w-1/2 pl-8"
    }, [_c('div', {
      staticClass: "bg-white p-4 rounded-lg border border-solid border-gray-200"
    }, [_c('div', {
      staticClass: "flex justify-between items-start mb-3"
    }, [_c('p', {
      staticClass: "font-semibold font-poppins text-gray-800"
    }, [_vm._v(_vm._s(user.users.name))]), _vm._v(" "), (user.turns !== null) ? _c('div', {
      staticClass: "rounded-tr-full rounded-br-full rounded-tl-full cursor-pointer flex items-center space-x-2 px-3 py-1",
      class: [_vm.setTurnProperties(user.turns.turn_type).backgroundColor]
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.setTurnIcon(user.turns.turn_type))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-white text-xs font-poppins font-medium"
    }, [_vm._v(_vm._s(_vm.setTurnProperties(user.turns.turn_type).title))])]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "font-poppins text-gray-700"
    }, [_vm._v(_vm._s(user.content))]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-2"
    }, [_c('p', {
      staticClass: "font-poppins font-light text-xs text-gray-700"
    }, [_vm._v(_vm._s(_vm.handleShowTranscriptDate(user.created_at)))])])]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-12 left-0 transform -translate-x-1/2 w-4 h-4 bg-gray-200 rounded-full border-2 border-white"
    })]) : _c('div', {
      staticClass: "relative w-1/2 pr-8"
    }, [_c('div', {
      staticClass: "bg-white p-4 rounded-lg border border-solid border-gray-200"
    }, [_c('div', {
      staticClass: "flex justify-between items-start mb-3"
    }, [_c('p', {
      staticClass: "font-semibold font-poppins text-gray-800"
    }, [_vm._v(_vm._s(user.users.name))]), _vm._v(" "), (user.turns !== null) ? _c('div', {
      staticClass: "rounded-tr-full rounded-br-full rounded-tl-full cursor-pointer flex items-center space-x-2 px-3 py-1",
      class: [_vm.setTurnProperties(user.turns.turn_type).backgroundColor]
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.setTurnIcon(user.turns.turn_type))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-white text-xs font-poppins font-medium"
    }, [_vm._v(_vm._s(_vm.setTurnProperties(user.turns.turn_type).title))])]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "font-poppins text-gray-700"
    }, [_vm._v(_vm._s(user.content))]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-end mt-2"
    }, [_c('p', {
      staticClass: "font-poppins font-light text-xs text-gray-700"
    }, [_vm._v(_vm._s(_vm.handleShowTranscriptDate(user.created_at)))])])]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-12 right-0 transform translate-x-1/2 w-4 h-4 bg-gray-200 rounded-full border-2 border-white"
    })])])
  })], 2), _vm._v(" "), (_vm.getCurrentDiscussion.is_live === true) ? _c('button', {
    staticClass: "bg-gray-50 hover:bg-gray-100 text-gray-800 font-poppins z-20 rounded-full px-3.5 py-2 flex items-center space-x-1 border border-solid border-gray-200",
    on: {
      "click": function($event) {
        return _vm.handleRefreshDiscussion()
      }
    }
  }, [_c('span', [_vm._v("Refresh")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid fa-rotate-right"
  })]) : _c('div', {
    staticClass: "bg-red-500 text-white z-20 rounded-full px-3.5 py-2 flex items-center space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-stop"
  }), _vm._v(" "), _c('span', [_vm._v("Discussion Stopped")])])]) : _c('div', {
    staticClass: "w-full lg:-ml-10 ml-0 h-full flex flex-col py-64 space-y-3 items-center justify-center"
  }, [_c('div', {
    staticClass: "w-full flex flex-col space-y-3 items-center text-center lg:w-6/12"
  }, [_c('img', {
    staticClass: "w-12 h-12",
    attrs: {
      "src": "/static/voice-recognition.png"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-3xl font-poppins font-semibold text-gray-800"
  }, [_vm._v("\n              Transcription\n            ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('button', {
    staticClass: "bg-pinky hover:bg-pinky-dark px-5 py-3 rounded-full text-white font-poppins font-medium",
    on: {
      "click": function($event) {
        return _vm.handleGoToActivateTranscription()
      }
    }
  }, [_vm._v("\n              Activate Transcription\n            ")]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "bg-green-700 text-white z-20 rounded-full px-3.5 py-2 flex items-center space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-play"
  }), _vm._v(" "), _c('span', [_vm._v("Discussion Started")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "font-poppins text-gray-800 font-light"
  }, [_vm._v("\n              Unlock the power of automatic transcription!"), _c('br'), _vm._v("\n              Easily convert your verbal discussion into text to make it easier to track and assess. "), _c('br'), _vm._v("\n              The Parlay Genie can generate a recap summary and follow up questions from the transcription."), _c('br'), _vm._v("\n              To start using this feature, enable transcription in your settings.\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2d1bb630!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/tabs/LDTranscriptionsTab.vue
// module id = 1802
// module chunks = 61